import { createAction } from '@reduxjs/toolkit';
import {
  ExportAdminLogsParams,
  GetAdminLogCategoriesResponse,
  GetAdminLogRequestParams,
  GetAdminLogsResponseWithPagination,
} from 'features/admin-logs/api/types';

export const adminLogsActions = {
  clearState: createAction('[admin_logs]CLEAR_ADMIN_LOGS_STATE'),
  getAdminLogsListRequest: createAction<GetAdminLogRequestParams>(
    '[admin_logs]GET_ADMIN_LOGS_LIST_REQUEST'
  ),
  getAdminLogsListSuccess: createAction<GetAdminLogsResponseWithPagination>(
    '[admin_logs]GET_ADMIN_LOGS_LIST_SUCCESS'
  ),
  getAdminLogsListFailure: createAction<string[]>(
    '[admin_logs]GET_ADMIN_LOGS_LIST_FAILURE'
  ),

  getAdminLogCategoriesRequest: createAction(
    '[admin_logs]GET_ADMIN_LOG_CATEGORIES_REQUEST'
  ),
  getAdminLogCategoriesSuccess: createAction<GetAdminLogCategoriesResponse>(
    '[admin_logs]GET_ADMIN_LOG_CATEGORIES_SUCCESS'
  ),
  getAdminLogCategoriesFailure: createAction<string[]>(
    '[admin_logs]GET_ADMIN_LOG_CATEGORIES_FAILURE'
  ),
  exportAdminLogsRequest: createAction<ExportAdminLogsParams>(
    '[admin_logs]EXPORT_ADMIN_LOGS_REQUEST'
  ),
  exportAdminLogsSuccess: createAction('[admin_logs]EXPORT_ADMIN_LOGS_SUCCESS'),
  exportAdminLogsFailure: createAction<string[]>(
    '[admin_logs]EXPORT_ADMIN_LOGS_FAILURE'
  ),
};
